<template>
    <div class="coupon-item">
        <div class="coupon-item-image">
            <img :src="(coupon.image && coupon.image !== 'null') ? coupon.image : junk" alt="Coupon">
        </div>
        <div class="coupon-item-content">
            <div>
                <div class="coupon-item-code">{{ coupon.code }}</div>
                <div class="coupon-item-description">{{ buildDescription(coupon) }}</div>
                <div class="coupon-item-expiration" v-if="coupon.expiration && coupon.expiration.end">
                    {{ formatDate(coupon.expiration.end) }}
                </div>
            </div>
            <div class="coupon-item-button">
                <button :disabled="coupon.min_order && parseFloat(coupon.min_order) > saleValue" @click="selectCoupon()">{{ getString('usar_cupom') }}</button>
                <button v-if="coupon.description && coupon.description !== 'null'" @click="viewRules()">{{ getString('ver_regras') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'

export default {
    name: 'AvailableCouponsCard',
    props: {
        coupon: {
            type: Object,
            required: true
        },
        saleValue: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            junk: require('../../../static/icons/junk-icon.png')
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        formatDate: function (date) {
            return `Válido até ${new Date(date).toLocaleDateString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
        },
        formatMoney: function (value) {
            return Util.formatMoney(value)
        },
        buildDescription: function (coupon) {
            let value = ''
            if (coupon.type === 'CASH_DISCOUNT') {
                value = `Desconto de ${this.formatMoney(coupon.value)}`
            } else if (coupon.type === 'PERCENTAGE_DISCOUNT') {
                value = `Desconto de ${coupon.value}%`
            } else if (coupon.type === 'CASHBACK') {
                value = `Cashback de ${this.formatMoney(coupon.value)}`
            } else if (coupon.type === 'FREE_DELIVERY') {
                value = 'Frete grátis'
            } else {
                value = coupon.description || 'Cupom de desconto'
            }

            if (coupon.min_order && parseFloat(coupon.min_order) > 0) {
                value += ` em pedidos acima de ${this.formatMoney(coupon.min_order)}`
            }

            return value
        },
        selectCoupon: function () {
            this.$emit('selectCoupon', this.coupon)
        },
        viewRules: function () {
            console.log('viewRules')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.coupon-item {
    display: flex;
    flex-direction: row;
    align-items: start;
    margin: 20px 0;
    padding: 15px;
    box-shadow: 0px 5px 15px 0 rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    height: auto;
    background: @white;

    .coupon-item-image {
        margin: 0 20px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 250px;

        img {
            width: 280px;
            min-height: 250px;
            object-fit: cover;
            border-radius: 10px;
        }
    }

    .coupon-item-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        min-height: 250px;

        .coupon-item-code {
            font-size: 35px;
            font-weight: bold;
            color: @primary-color;
        }

        .coupon-item-description {
            margin: 10px 0 30px 0;
            font-size: 25px;
            color: #5e5e5e;
        }

        .coupon-item-expiration {
            margin: 10px 0 15px 0;
            font-size: 25px;
            color: #5e5e5e;
        }

        .coupon-item-button {
            display: flex;
            flex-direction: row;

            button {
                font-size: 35px;
                margin: 0;
                padding: 10px 20px;
                border-radius: 10px;
                border: none;
                box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
                color: @white;
                background: @primary-color;
                width: 100%;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    opacity: 0.9;
                }

                &:active {
                    transform: scale(0.98);
                }

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }
            }
        }
    }
}

@media (max-width: 698px) {
    // Gertec SK210
    .coupon-item {
        margin: 10px 0;
        padding: 8px;
        border-radius: 5px;
        flex-direction: row;

        .coupon-item-image {
            margin: 0;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            align-self: center;

            img {
                width: 140px;
                min-height: 80px;
                border-radius: 5px;
            }
        }

        .coupon-item-content {
            min-height: auto;

            .coupon-item-code {
                font-size: 17px;
            }

            .coupon-item-description {
                margin: 5px 0 15px 0;
                font-size: 12px;
            }

            .coupon-item-expiration {
                margin: 5px 0 8px 0;
                font-size: 12px;
            }

            .coupon-item-button button {
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 5px;
                height: 30px;
            }
        }
    }
}

@media (min-width: 901px) and (max-width: 1025px) {
    //@tablet
    .coupon-item {
        margin: 17px 0;
        padding: 13px;
        border-radius: 8px;

        .coupon-item-image {
            margin: 0 17px 0 0;
            height: 212px;

            img {
                width: 238px;
                min-height: 212px;
                border-radius: 8px;
            }
        }

        .coupon-item-content {
            min-height: 212px;

            .coupon-item-code {
                font-size: 30px;
            }

            .coupon-item-description {
                margin: 8px 0 25px 0;
                font-size: 21px;
            }

            .coupon-item-expiration {
                margin: 8px 0 13px 0;
                font-size: 21px;
            }

            .coupon-item-button button {
                font-size: 30px;
                padding: 8px 17px;
                border-radius: 8px;
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 900px) {
    //@mehloretec
    .coupon-item {
        margin: 15px 0;
        padding: 11px;
        border-radius: 8px;

        .coupon-item-image {
            margin: 0 15px 0 0;
            height: 188px;

            img {
                width: 210px;
                min-height: 188px;
                border-radius: 8px;
            }
        }

        .coupon-item-content {
            min-height: 188px;

            .coupon-item-code {
                font-size: 26px;
            }

            .coupon-item-description {
                margin: 8px 0 23px 0;
                font-size: 19px;
            }

            .coupon-item-expiration {
                margin: 8px 0 11px 0;
                font-size: 19px;
            }

            .coupon-item-button button {
                font-size: 26px;
                padding: 8px 15px;
                border-radius: 8px;
            }
        }
    }
}

@media (orientation: landscape) {
    .coupon-item {
        margin: 15px 0;
        padding: 11px;
        border-radius: 8px;

        .coupon-item-image {
            margin: 0 15px 0 0;
            height: 188px;

            img {
                width: 210px;
                min-height: 188px;
                border-radius: 8px;
            }
        }

        .coupon-item-content {
            min-height: 188px;

            .coupon-item-code {
                font-size: 26px;
            }

            .coupon-item-description {
                margin: 8px 0 23px 0;
                font-size: 19px;
            }

            .coupon-item-expiration {
                margin: 8px 0 11px 0;
                font-size: 19px;
            }

            .coupon-item-button button {
                font-size: 26px;
                padding: 8px 15px;
                border-radius: 8px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FidelityComponents/AvailableCouponsCard.vue